module.exports = __webpack_public_path__ + "img/linea.90010a7d.png";